import React from "react"
import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS, colors } from "@/styles/themeSettings"
import CommonIcon from "@/components/common/Icon/Icon"
import { ICONS } from "@/constants"
import useCurrentBranchData from "@/hooks/useCurrentBranchData"
import Text from "@/components/common/Text"
import useGlobals from "@/hooks/useGlobals"

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	row-gap: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};
	margin-left: var(--local-padding-x);

	.containers-heading {
		margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		row-gap: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
	}
`

const StyledSingleFileBlockWrapper = styled.a`
	display: block;
	border: 1px solid var(--color);
	width: fit-content;
	--color: ${({ theme }) => theme.colors.richBlack};

	transition: all var(--rgr-duration) var(--ease);

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		&:hover {
			background: ${({ theme }) => theme.colors.periwinkle};
		}
	}
`

const StyledSingleFileBlock = styled.div`
	cursor: pointer;
	display: flex;
	gap: ${getCssSizeValue(24)};
	align-items: center;
	border: 1px solid var(--color);
	padding: ${getCssSizeValue(13, BREAKPOINTS.MOBILE)} ${getCssSizeValue(54, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(13, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(13)} ${getCssSizeValue(54)} ${getCssSizeValue(13)} ${getCssSizeValue(16)};
	}

	p {
		color: var(--color) !important;
		text-decoration: none;
	}
`

const Icon = styled(CommonIcon)`
	width: ${getCssSizeValue(14, BREAKPOINTS.DESKTOP)};
`

const DownloadFiles = ({ className = "", ...props }) => {
	const branch = useCurrentBranchData()
	const { containersLocationsHeading } = useGlobals()
	const downloadFiles = branch?.downloadFiles?.downloadFilesBlocks || []
	return (
		<Wrapper className={`${className}`} {...props}>
			<Text className="containers-heading typo-borna-19">{containersLocationsHeading}</Text>
			{downloadFiles.map((item) => {
				const fileName = item?.fileVisibleName || ""
				const fileUrl = item?.file?.url || ""
				return (
					<StyledSingleFileBlockWrapper key={fileName} href={fileUrl} target="_blank" rel="noopener noreferrer" download>
						<StyledSingleFileBlock>
							<Icon name={ICONS.ATTACHMENT} color={colors.richBlack} />
							<p className="typo-strawford typo-strawford-12">{fileName}</p>
						</StyledSingleFileBlock>
					</StyledSingleFileBlockWrapper>
				)
			})}
		</Wrapper>
	)
}

export default DownloadFiles
